/* eslint-disable */
import MyPreloader from '../MyPreloader'
import UiModal from '../modals/UiModal'
import MyModal from '../ui/MyModal'
import axios from 'axios'

export default {
	components: { MyPreloader, UiModal, MyModal },
	data() {
		return {
			form: {
				isCheck: false,
			},
			contentPersPr: null,
			isSubmitting: false,
			headerTitle: null,
		}
	},
	computed: {
		submitBtnActive() {
			// По умолчанию, кнопка должна быть активна
			// при нажатии на нее, должна показываться валидация,
			// но при этом, кнопка всегда неактивна, если форма уже отправлена
			// за это отвечает поле isSubmitting
			if (this.isSubmitting) {
				return true
			} else if (!this.form.isCheck) {
				return true
			}
		},
	},
	watch: {},
	methods: {
		getPersProcessing() {
			if (this.axios) {
				this.axios
					.get(`/api/v2/content/policy/?code=${this.idPersPr}`)
					.then(response => {
						this.contentPersPr = response.data.data.props.text
						this.setClasses()
					})
				return
			}
			axios
				.get(`/api/v2/content/policy/?code=${this.idPersPr}`)
				.then(response => {
					this.contentPersPr = response.data.data.props.text
					this.setClasses()
				})
		},
		showModal() {
			this.getPersProcessing()
		},
		setClasses() {
			let textHtml = this.contentPersPr
			var htmlObject = document.createElement('div')
			htmlObject.innerHTML = textHtml
			htmlObject.querySelector('p').classList.add('content-title', 'n-mb-3')
			// ---
			if (this.$refs.uiModal) {
				this.headerTitle = htmlObject.querySelector('.content-title').innerHTML
				htmlObject.querySelector('.content-title').remove()
			}
			// ---
			let paragraph = htmlObject.querySelectorAll('p')
			paragraph.forEach(el => {
				if (el.classList.contains('content-title')) {
					return
				} else {
					el.classList.add(
						'page-notification',
						'page-notification_black',
						'n-mb-2'
					)
				}
			})
			let ulList = htmlObject.querySelectorAll('ul')
			ulList.forEach(el => {
				el.classList.add(
					'bullet-list',
					'bullet-list_smaller',
					'black-bullet',
					'bullet-list-text',
					'n-mb-3'
				)
			})
			let liist = htmlObject.querySelectorAll('li')
			liist.forEach(el => {
				el.classList.add('bullet-list__item')
			})
			this.contentPersPr = htmlObject.innerHTML
		},
	},
}
